import { type ReactNode, createContext } from 'react';
import type { AppRoutesPaths } from '@/shared/constants/app-routes';

// Definição do tipo para mensagens
export interface TutorialChatMessage {
	id: string;
	text?: string;
	delay: number;
	options?: TutorialChatMessageOption[];
	user?: boolean;
	selectedOptionId?: string;
	messageContent?: ReactNode;
}

export interface TutorialChatMessageOption {
	id: string;
	option: string;
	redirect_url?: AppRoutesPaths;
}

// Definição do tipo para o estado do chat
interface TutorialChatContextType {
	messages: Record<string, TutorialChatMessage[]>; // Usa um objeto para armazenar diferentes chats
	addMessage: (chatId: string, message: TutorialChatMessage) => void;
	resetChat: (chatId: string) => void;
}

// Criando contexto
export const TutorialChatContext = createContext<TutorialChatContextType | undefined>(undefined);
